import { useTranslation } from "react-i18next";
import Api from "../../../../../Api";
import TeambookDialog from "../../../../default_components/TeambookDialog";
import PropTypes from "prop-types";
import DangerPic from "../../../../default_images/danger_deletion.svg";

export default function DeleteHoliday({ onCloseSelectedModal, selectedHoliday, getHolidays }) {
  const { t } = useTranslation();

  const deleteHoliday = (id) => {
    Api.Integrations.Holidays.delete(id).then(() => {
      getHolidays();
    });
  };

  return (
    <TeambookDialog
      open
      onClose={onCloseSelectedModal}
      withCloseButton
      title={" "}
      content={
        <div style={{display: "flex", flexDirection: "column", alignItems: "center"}}>
          <img style={{margin: "0 0 20px 0", width: 60, justifySelf: "center"}} alt={"danger"} src={DangerPic}/>
          <p style={{marginBottom: 0}}>{t("settings.time_off.delete_holiday")}</p>
        </div>
      }
      actionButtons={
        [
          {
            text: t("delete"),
            onClick: () => {
              deleteHoliday(selectedHoliday);
              onCloseSelectedModal();
            },
            id: "deleteHolidayButton",
          },
        ]
      }
    />
  );
}

DeleteHoliday.propTypes = {
  onCloseSelectedModal: PropTypes.func.isRequired,
  selectedHoliday: PropTypes.string.isRequired,
  getHolidays: PropTypes.func.isRequired,
}
